import axios from 'axios';
import { URL_GET_CONTACTS_FOR_CUSTOMER } from 'constants/urls';

const getContacts = async (customerId) => {
	const { data } = await axios({
		method: 'GET',
		url: `${URL_GET_CONTACTS_FOR_CUSTOMER}${customerId}`,
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
	});
	return data;
};

export default getContacts;
